import React, { useRef, useEffect, useCallback } from 'react';

/**
 * SVG icon components for search result categories
 */
const ICONS = {
  chart: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" /><line x1="12" y1="20" x2="12" y2="4" /><line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  ),
  shop: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
  scan: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 7V5a2 2 0 0 1 2-2h2" /><path d="M17 3h2a2 2 0 0 1 2 2v2" /><path d="M21 17v2a2 2 0 0 1-2 2h-2" /><path d="M7 21H5a2 2 0 0 1-2-2v-2" /><line x1="7" y1="12" x2="17" y2="12" />
    </svg>
  ),
  bot: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="10" rx="2" /><circle cx="12" cy="5" r="2" /><path d="M12 7v4" /><line x1="8" y1="16" x2="8" y2="16" /><line x1="16" y1="16" x2="16" y2="16" />
    </svg>
  ),
  video: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="23 7 16 12 23 17 23 7" /><rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
    </svg>
  ),
  analytics: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  refresh: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" /><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  users: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  monitor: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" />
    </svg>
  ),
  grid: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
    </svg>
  ),
  'credit-card': (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  headphones: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 18v-6a9 9 0 0 1 18 0v6" /><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" />
    </svg>
  ),
  book: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" /><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  settings: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  ),
  sun: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="5" /><line x1="12" y1="1" x2="12" y2="3" /><line x1="12" y1="21" x2="12" y2="23" /><line x1="4.22" y1="4.22" x2="5.64" y2="5.64" /><line x1="18.36" y1="18.36" x2="19.78" y2="19.78" /><line x1="1" y1="12" x2="3" y2="12" /><line x1="21" y1="12" x2="23" y2="12" /><line x1="4.22" y1="19.78" x2="5.64" y2="18.36" /><line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  ),
  task: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
    </svg>
  ),
  search: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  clock: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  arrow: (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
  ),
};

function getIcon(iconName) {
  return ICONS[iconName] || ICONS.search;
}

/**
 * Highlight matching text in a string
 */
function HighlightText({ text, query }) {
  if (!query || !text) return <>{text}</>;
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return <>{text}</>;

  const escaped = words.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const regex = new RegExp(`(${escaped.join('|')})`, 'gi');
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) => {
        const isMatch = words.some((w) => part.toLowerCase() === w);
        return isMatch ? (
          <span key={i} style={{ color: '#00d4ff', fontWeight: 600 }}>{part}</span>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </>
  );
}

/**
 * Individual search result item
 */
function SearchResultItem({ item, isSelected, query, onClick, onMouseEnter }) {
  const itemRef = useRef(null);

  useEffect(() => {
    if (isSelected && itemRef.current) {
      itemRef.current.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, [isSelected]);

  const isEmoji = typeof item.icon === 'string' && item.icon.length <= 2 && /\p{Emoji}/u.test(item.icon);

  return (
    <button
      ref={itemRef}
      type="button"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 16px',
        background: isSelected ? 'rgba(102, 126, 234, 0.15)' : 'transparent',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background 0.1s ease',
        textAlign: 'left',
        color: 'inherit',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '32px',
        height: '32px',
        borderRadius: '8px',
        background: isSelected ? 'rgba(102, 126, 234, 0.25)' : 'rgba(102, 126, 234, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#667eea',
        flexShrink: 0,
        fontSize: isEmoji ? '1.1rem' : '0.85rem',
        transition: 'background 0.1s ease',
      }}>
        {isEmoji ? item.icon : getIcon(item.icon)}
      </div>

      {/* Title + Subtitle */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '0.85rem',
          fontWeight: 500,
          color: 'var(--text-primary, #fff)',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
          <HighlightText text={item.title} query={query} />
        </div>
        {item.subtitle && (
          <div style={{
            fontSize: '0.75rem',
            color: 'var(--text-muted, rgba(255,255,255,0.5))',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            marginTop: '1px',
          }}>
            <HighlightText text={item.subtitle} query={query} />
          </div>
        )}
      </div>

      {/* Shortcut badge or arrow */}
      {item.shortcut ? (
        <div style={{
          display: 'flex',
          gap: '4px',
          flexShrink: 0,
        }}>
          {item.shortcut.split('+').map((key, i) => (
            <kbd key={i} style={{
              padding: '2px 6px',
              borderRadius: '4px',
              background: 'rgba(102, 126, 234, 0.12)',
              border: '1px solid rgba(102, 126, 234, 0.2)',
              color: 'var(--text-muted, rgba(255,255,255,0.5))',
              fontSize: '0.65rem',
              fontFamily: 'Inter, system-ui, sans-serif',
              fontWeight: 500,
              lineHeight: 1.4,
            }}>
              {key === 'Ctrl' ? (navigator.platform?.includes('Mac') ? 'Cmd' : 'Ctrl') : key}
            </kbd>
          ))}
        </div>
      ) : isSelected ? (
        <div style={{
          color: 'var(--text-muted, rgba(255,255,255,0.4))',
          flexShrink: 0,
          opacity: 0.6,
        }}>
          {ICONS.arrow}
        </div>
      ) : null}
    </button>
  );
}

/**
 * Category header within results
 */
function CategoryHeader({ title, count }) {
  return (
    <div style={{
      padding: '8px 16px 4px',
      fontSize: '0.7rem',
      fontWeight: 600,
      color: 'var(--text-muted, rgba(255,255,255,0.45))',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <span>{title}</span>
      <span style={{ fontSize: '0.65rem', fontWeight: 400 }}>{count}</span>
    </div>
  );
}

const kbdStyle = {
  padding: '1px 5px',
  borderRadius: '4px',
  background: 'rgba(102, 126, 234, 0.1)',
  border: '1px solid rgba(102, 126, 234, 0.15)',
  fontSize: '0.65rem',
  fontFamily: 'Inter, system-ui, sans-serif',
  fontWeight: 500,
  lineHeight: 1.4,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '18px',
};

/**
 * GlobalSearch -- Command palette style search modal.
 * All search state is passed in as props from the useGlobalSearch hook.
 */
const GlobalSearch = ({
  isOpen,
  close,
  query,
  setQuery,
  debouncedQuery,
  results,
  flatItems,
  selectedIndex,
  setSelectedIndex,
  handleKeyDown,
  executeItem,
  tasksLoading,
  recentSearches,
  handleClearRecentSearches,
  handleSelectRecent,
}) => {
  const inputRef = useRef(null);
  const overlayRef = useRef(null);

  // Focus input when opening
  useEffect(() => {
    if (isOpen && inputRef.current) {
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    }
  }, [isOpen]);

  // Handle backdrop click
  const handleBackdropClick = useCallback((e) => {
    if (e.target === overlayRef.current) {
      close();
    }
  }, [close]);

  // Track flat index across groups for keyboard navigation
  let globalIndex = 0;

  if (!isOpen) return null;

  const showRecentSearches = !debouncedQuery && recentSearches.length > 0;
  const showEmptyState = debouncedQuery && flatItems.length === 0;
  const isMac = navigator.platform?.includes('Mac');

  return (
    <div
      ref={overlayRef}
      onClick={handleBackdropClick}
      role="dialog"
      aria-label="Global Search"
      aria-modal="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        paddingTop: '15vh',
        animation: 'globalSearchFadeIn 0.15s ease-out',
      }}
    >
      {/* Search panel */}
      <div
        className="global-search-panel"
        onKeyDown={handleKeyDown}
        style={{
          width: '100%',
          maxWidth: '580px',
          margin: '0 16px',
          background: 'var(--bg-secondary, rgba(10, 10, 15, 0.98))',
          border: '1px solid rgba(102, 126, 234, 0.3)',
          borderRadius: '16px',
          boxShadow: '0 25px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(102, 126, 234, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '70vh',
          overflow: 'hidden',
          animation: 'globalSearchSlideIn 0.15s ease-out',
        }}
      >
        {/* Search input area */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '16px 20px',
          borderBottom: '1px solid rgba(102, 126, 234, 0.15)',
        }}>
          <div style={{ color: '#667eea', flexShrink: 0, display: 'flex' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <input
            ref={inputRef}
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search pages, apps, tasks, actions..."
            aria-label="Search"
            autoComplete="off"
            spellCheck="false"
            style={{
              flex: 1,
              background: 'transparent',
              border: 'none',
              outline: 'none',
              color: 'var(--text-primary, #fff)',
              fontSize: '0.95rem',
              fontFamily: 'Inter, system-ui, sans-serif',
              caretColor: '#00d4ff',
            }}
          />
          <kbd style={{
            padding: '2px 8px',
            borderRadius: '6px',
            background: 'rgba(102, 126, 234, 0.1)',
            border: '1px solid rgba(102, 126, 234, 0.2)',
            color: 'var(--text-muted, rgba(255,255,255,0.4))',
            fontSize: '0.7rem',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontWeight: 500,
            cursor: 'pointer',
            flexShrink: 0,
          }}
          onClick={close}
          >
            ESC
          </kbd>
        </div>

        {/* Results area */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '8px',
        }}>
          {/* Recent searches */}
          {showRecentSearches && (
            <div>
              <div style={{
                padding: '8px 16px 4px',
                fontSize: '0.7rem',
                fontWeight: 600,
                color: 'var(--text-muted, rgba(255,255,255,0.45))',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <span>Recent Searches</span>
                <button
                  onClick={handleClearRecentSearches}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#667eea',
                    fontSize: '0.65rem',
                    cursor: 'pointer',
                    padding: 0,
                    fontWeight: 400,
                  }}
                >
                  Clear
                </button>
              </div>
              {recentSearches.map((search, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => handleSelectRecent(search)}
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '8px 16px',
                    background: 'transparent',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    textAlign: 'left',
                    color: 'inherit',
                    transition: 'background 0.1s ease',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(102, 126, 234, 0.1)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                >
                  <div style={{ color: 'var(--text-muted, rgba(255,255,255,0.4))', display: 'flex', flexShrink: 0 }}>
                    {ICONS.clock}
                  </div>
                  <span style={{
                    fontSize: '0.85rem',
                    color: 'var(--text-secondary, rgba(255,255,255,0.7))',
                  }}>
                    {search}
                  </span>
                </button>
              ))}
              <div style={{
                height: '1px',
                background: 'rgba(102, 126, 234, 0.1)',
                margin: '8px 16px',
              }} />
            </div>
          )}

          {/* Loading indicator for tasks */}
          {tasksLoading && debouncedQuery && (
            <div style={{
              padding: '8px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: 'var(--text-muted, rgba(255,255,255,0.4))',
              fontSize: '0.8rem',
            }}>
              <div className="loading-spinner" style={{ width: '14px', height: '14px' }} />
              Loading tasks...
            </div>
          )}

          {/* Grouped results */}
          {results.map((group) => {
            const items = group.items.map((item) => {
              const currentGlobalIndex = globalIndex;
              globalIndex++;
              return (
                <SearchResultItem
                  key={item.id}
                  item={item}
                  isSelected={currentGlobalIndex === selectedIndex}
                  query={debouncedQuery}
                  onClick={() => executeItem(item)}
                  onMouseEnter={() => setSelectedIndex(currentGlobalIndex)}
                />
              );
            });

            return (
              <div key={group.category}>
                <CategoryHeader title={group.category} count={group.items.length} />
                {items}
              </div>
            );
          })}

          {/* Empty state */}
          {showEmptyState && (
            <div style={{
              padding: '40px 16px',
              textAlign: 'center',
            }}>
              <div style={{
                color: 'var(--text-muted, rgba(255,255,255,0.3))',
                fontSize: '0.9rem',
                marginBottom: '8px',
              }}>
                No results found
              </div>
              <div style={{
                color: 'var(--text-muted, rgba(255,255,255,0.2))',
                fontSize: '0.8rem',
              }}>
                Try a different search term
              </div>
            </div>
          )}

          {/* Default hints when no query and no recent searches */}
          {!debouncedQuery && !showRecentSearches && (
            <div style={{ padding: '8px' }}>
              <CategoryHeader title="Quick Navigation" count={''} />
              {[
                { id: 'hint-dashboard', title: 'Dashboard', subtitle: 'Overview and metrics', icon: 'chart', path: '/dashboard', shortcut: 'Ctrl+D' },
                { id: 'hint-settings', title: 'Settings', subtitle: 'Account and app settings', icon: 'settings', path: '/settings', shortcut: 'Ctrl+,' },
                { id: 'hint-theme', title: 'Toggle Theme', subtitle: 'Switch between dark and light mode', icon: 'sun', actionType: 'theme' },
              ].map((item, i) => (
                <SearchResultItem
                  key={item.id}
                  item={item}
                  isSelected={i === selectedIndex}
                  query=""
                  onClick={() => executeItem(item)}
                  onMouseEnter={() => setSelectedIndex(i)}
                />
              ))}
            </div>
          )}
        </div>

        {/* Footer with keyboard hints */}
        <div style={{
          padding: '10px 20px',
          borderTop: '1px solid rgba(102, 126, 234, 0.1)',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          fontSize: '0.7rem',
          color: 'var(--text-muted, rgba(255,255,255,0.35))',
          flexWrap: 'wrap',
        }}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <kbd style={kbdStyle}>
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="19" x2="12" y2="5" /><polyline points="5 12 12 5 19 12" />
              </svg>
            </kbd>
            <kbd style={kbdStyle}>
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" />
              </svg>
            </kbd>
            Navigate
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <kbd style={kbdStyle}>Enter</kbd>
            Select
          </span>
          <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <kbd style={kbdStyle}>Esc</kbd>
            Close
          </span>
          <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '4px' }}>
            <kbd style={kbdStyle}>{isMac ? 'Cmd' : 'Ctrl'}</kbd>
            <kbd style={kbdStyle}>K</kbd>
            Search
          </span>
        </div>
      </div>

      {/* Animation styles */}
      <style>{`
        @keyframes globalSearchFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes globalSearchSlideIn {
          from {
            opacity: 0;
            transform: translateY(-10px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default GlobalSearch;
